import { identifier, ttq } from "src/vendor/tiktok";
import { registerHandler } from "../handler";

// List of available tiktok events and available parameters:
// https://ads.tiktok.com/marketing_api/docs?rid=5ipocbxyw8v&id=1701890973258754

// Used when we need to send ttq event to 1 instance, but not all of them
const getTtqInstance = (id) => {
  return ttq.instance(id);
};

export default function registerHandlers() {
  registerHandler("startMainSurvey", () => {
    ttq.track("ViewContent", {
      content_name: "mainSurvey",
      content_type: "product",
    });
  });
  registerHandler("lead", ({ emailHashes }) => {
    if (emailHashes) {
      ttq.identify({ email: emailHashes.sha256 });
    }
    // This seems like the closest event TikTok has for "lead"?
    ttq.track("Contact");
  });

  registerHandler("purchase", ({ order, plan }) => {
    // Only tracked for v1, so we track it via an instance
    getTtqInstance(identifier).track("CompletePayment", {
      // Fall back to plan price since that will (always?) be a round dollar value and we can
      // distinguish if such a fallback occurred.
      value: order?.eltv_13_months || plan?.plan_price || 0,
      currency: plan?.currency || "USD",
      content_type: "product",
      content_id: plan?.noom_plan_id,
    });
  });
}
